<template>
    <div>
        <!-- 文章详情{{newid}} -->
        <div class="border-title  font-s24 c33">{{list.title}}</div>
        <div v-html="list.content" class="font-s14 c66"></div>
    </div>
</template>

<script>
import { NewsInfo } from "../../api/api";
export default {
  data() {
    return {
      newid: this.$route.query.newid,
      list: ""
    };
  },
  created() {
    var db = {
      newid: this.newid
    };
    this.$axios.post(NewsInfo, db).then(
      res => {
        if (res.data.code == 1) {
          this.list = res.data.data;
        } else {
          this.list = "";
        }
      },
      err => {
        this.list = "";
      }
    );
  }
};
</script>

<style>
</style>
